import React from "react"
import Relay from "react-relay"
import { withRouter } from "react-router"
//import Helmet from "react-helmet";
import MediaUpload from "../modules/MediaUpload"
import { injectIntl } from "react-intl"
import contributeMessages from "../../messages/imageUpload"

class EditMediaForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      unsaved: false
    }
  }

  render() {
    return (
      <main id="main" role="main" data-article-style="default" tabIndex={0}>
        <article className="c-article min-height-page">
          <div className="image-upload-area single-column single-column--skinny">
            <MediaUpload
              showMediaClear={true}
              resource={this.props.resource}
              handleSaved={this._onSave}
              handleUnsaved={this._handleUnsaved}
            />
          </div>
        </article>
      </main>
    )
  }

  componentWillMount() {
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave)
  }

  routerWillLeave = () => {
    if (this.state.unsaved)
      return this.props.intl.formatMessage(
        contributeMessages.unsavedInformation
      )
  }

  _onSave = res => {
    this.setState({
      unsaved: false
    })
  }

  _handleUnsaved = () => {
    this.setState({
      unsaved: true
    })
  }

  _uploadAnother = e => {
    e.preventDefault()

    this.setState({
      uuid: null
    })
  }
}

export default Relay.createContainer(withRouter(injectIntl(EditMediaForm)), {
  fragments: {
    resource: () => Relay.QL`
        fragment on Resource {
            ${MediaUpload.getFragment("resource")}
        }
        `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/pages/EditMediaForm.js